import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { FaTrash, FaEye } from "react-icons/fa";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import "./styles.scss";
import {
  changeStatusServicio,
  getCategorias,
} from "../../../helpers/Servicios.helper";
import { Modal, Descriptions, Image, Table, Button, Col, Rate } from "antd";
import { createNotification } from "../../../utils/utils";

const ServiciosTable = ({ dataServicios, history }) => {
  const [data, setData] = useState([]);
  const [dataSelect, setDataSelect] = useState();
  const [statusTecnico, setStatusTecnico] = useState(false);
  const [actionProgress, setActionProgress] = useState(false);
  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
  });
  const { SearchBar } = Search;
  const [flagModal, setFlagModal] = useState({
    modal1: false,
    modal2: false,
    modal3: false,
  });
  const rowEvents = {
    onClick: async (e, row, rowIndex) => {
      if (row.stateNumServi > 2) {
        console.log("--MensajeriaTable.Table.rowEvents-- ");
        setDataSelect(row);
        setFlagModal({ ...flagModal, modal1: true });
      } else {
        createNotification(
          "Espere a que el tecnico haga la cotización",
          "warn"
        );
      }
    },
  };

  const renderColumns = () => {
    console.log("--MensajeriaTable.Table.renderColumns-- ");
    return [
      {
        dataField: "index",
        text: "#",
        sort: true,
        headerStyle: () => {
          return { width: "5%" };
        },
      },
      {
        dataField: "id_categoria.nameCategory",
        text: "Tipo de Servicio",
        sort: true,
        headerStyle: () => {
          return { width: "10%" };
        },
      },
      {
        dataField: "changeStatus",
        text: "Estado",
        sort: true,
        headerStyle: () => {
          return { width: "10%" };
        },
      },
      {
        dataField: "tecniconame",
        text: "Tecnico Asignado",
        sort: true,
        headerStyle: () => {
          return { width: "10%" };
        },
      },
      {
        dataField: "fecha_servicio",
        text: "Fecha del Servicio",
        sort: true,
        headerStyle: () => {
          return { width: "10%" };
        },
      },
      {
        dataField: "hora_servicio",
        text: "Hora del Servicio",
        sort: true,
        headerStyle: () => {
          return { width: "10%" };
        },
      },
      {
        dataField: "options",
        text: "",
        headerStyle: () => {
          return { width: "10%" };
        },
        formatter: (cellContent, row) => (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
            disabled={true}
          >
            <div style={{ cursor: "pointer" }}>
              <FaEye />
            </div>
          </div>
        ),
      },
    ];
  };

  const renderData = () => {
    console.log("--MensajeriaTable.Table.renderServicios-- ");
    if (
      dataServicios !== undefined &&
      dataServicios !== null &&
      Array.isArray(dataServicios)
    ) {
      return dataServicios.map((item, index) => {
        return {
          ...item,
          tecniconame: item.id_tecnico
            ? `${item.id_tecnico.name} ${item.id_tecnico.lastname}`
            : "",
          index: index + 1,
        };
      });
    }
    return [];
  };
  const columnsModal = [
    {
      title: "Recurso",
      dataIndex: "name",
    },

    {
      title: "Precio",
      dataIndex: "price",
      render: (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
    },
  ];

  const handleGiveService = async (type) => {
    try {
      let handleFlag = 0;
      let body = {};
      setActionProgress(true);
      switch (type) {
        case 0:
          body = { ...dataSelect, id_servicio: dataSelect._id, id_estado: 6 };
          handleFlag = 2;

          break;
        case 1:
          body = {
            rateServicio: dataSelect.rateServicio,
            id_servicio: dataSelect._id,
            id_estado: 11,
          };
          break;
        default:
          body = {
            ...dataSelect,
            id_servicio: dataSelect._id,
            id_estado: 7,
            rateServicio: -2,
            price_total: 20000,
          };
          handleFlag = 3;
          break;
      }

      const response = await changeStatusServicio(body);
      if (response["status"] == 200) {
        createNotification(
          handleFlag == 2
            ? "Cotizacion Aceptada por el cliente"
            : handleFlag == 3
            ? "Cotizacion Rechazada"
            : "Gracias por Calificar nuestro servicio",
          "success"
        );
        setFlagModal({ ...flagModal, modal1: false });
        setActionProgress(false);
        setInterval(() => {
          window.location.reload();
        }, 2000);
      } else {
        createNotification(
          handleFlag == 2
            ? "Error al aceptar la cotizacion"
            : handleFlag == 3
            ? "Error Rechazar cotizacion"
            : "Error al Calificar",
          "error"
        );
        setActionProgress(false);
      }
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <div className="container">
        <div className="row row-table">
          <div className="col">
            <ToolkitProvider
              keyField="id"
              data={renderData()}
              columns={renderColumns()}
              search
            >
              {(props) => (
                <div>
                  <div className="clearfix">
                    <div className="float-left search-container">
                      <SearchBar style ={{borderRadius: '20px'}} {...props.searchProps} placeholder="Buscar" />
                    </div>
                  </div>
                  <div className={`card shadow h-100 card-table`}>
                    <div className="card-body">
                      <BootstrapTable
                        {...props.baseProps}
                        pagination={pagination}
                        bordered={false}
                        striped={false}
                        bootstrap4={true}
                        rowEvents={rowEvents}
                        noDataIndication="No has generado ningún servicio aún, qué esperas?"
                      />
                    </div>
                  </div>
                </div>
              )}
            </ToolkitProvider>
          </div>
          {flagModal["modal1"] ? (
            <Modal
              visible={flagModal["modal1"]}
              footer={[]}
              onCancel={() => setFlagModal({ ...flagModal, modal1: false })}
            >
              <Descriptions
                // style = {{height: 500, overflow: 'scroll'}}

                title="Cotización"
                layout="vertical"
                bordered
              >
                {dataSelect.aplazados.length > 0 ? (
                  <Descriptions.Item label="Fecha de Aplazamiento" span={3}>
                    {`${
                      dataSelect.aplazados[
                        dataSelect.aplazados.length - 1
                      ].fecha.split("T")[0]
                    } ${
                      dataSelect.aplazados[dataSelect.aplazados.length - 1].hora
                    }`}
                  </Descriptions.Item>
                ) : (
                  ""
                )}
                <Descriptions.Item label="Tecnico" span={3}>
                  {dataSelect.tecniconame}
                </Descriptions.Item>
                <Descriptions.Item label="Fotos" span={3}>
                  {dataSelect.nameUrl.map((e) => {
                    return <Image width={100} src={e} />;
                  })}
                </Descriptions.Item>
                <Descriptions.Item label="Descripción del Diagnostico" span={3}>
                  {dataSelect.desc_diagnostico}
                </Descriptions.Item>
                <Descriptions.Item label="Posible Solucición" span={3}>
                  {dataSelect.posible_solucion}
                </Descriptions.Item>

                <Descriptions.Item label="Recursos- Costos" span={3}>
                  <Table
                    dataSource={dataSelect.herramientas}
                    columns={columnsModal}
                    scroll={{ y: 100 }}
                    pagination={false}
                  />
                </Descriptions.Item>
                <Descriptions.Item label="Precio" span={3}>
                  {`$${dataSelect.price_total}`}
                </Descriptions.Item>

                {dataSelect.stateNumServi == 7 || dataSelect.stateNumServi == 11  ? (
                  <Descriptions.Item
                    label="Fotos Finalizado el Arreglo"
                    span={3}
                  >
                    {dataSelect.url_img_fin.map((e) => {
                      return <Image width={100} src={e} />;
                    })}
                  </Descriptions.Item>
                ) : (
                  ""
                )}

                {dataSelect.stateNumServi == 6 ? (
                  <Descriptions.Item
                    label="Estado del Tecnico"
                    contentStyle={{ fontWeight: "bold" }}
                    style={{ textAlign: "center" }}
                    span={3}
                  >
                    El Técnico esta trabajando ! <br />
                    Puede Tardar un tiempo ...
                  </Descriptions.Item>
                ) : dataSelect.stateNumServi == 11 ? (
                  <Descriptions.Item label="Calificación" span={3}>
                    <Rate disabled value={dataSelect.rateServicio} />
                  </Descriptions.Item>
                ) : (
                  ""
                )}
              </Descriptions>
              <div style={{ padding: "10px" }}>
                {dataSelect.stateNumServi == 7 &&
                dataSelect.rateServicio != -2 ? (
                  <Button
                    style={{ alignItems: "center" }}
                    onClick={() => setFlagModal({ ...flagModal, modal3: true })}
                  >
                    Calificar Servicio
                  </Button>
                ) : (
                  <>
                    <Button
                      hidden={
                        dataSelect.stateNumServi == 6 ||
                        dataSelect.stateNumServi == 11 ||
                        dataSelect.rateServicio == -2 || 
                        dataSelect.price_total <= 0
                      }
                      disabled={
                        actionProgress || dataSelect.stateNumServi == "4"
                      }
                      type="primary"
                      className="buttonModal"
                      onClick={() => handleGiveService(0)}
                    >
                      Aceptar
                    </Button>
                    <Button
                      hidden={
                        dataSelect.stateNumServi == 6 ||
                        dataSelect.stateNumServi == 11 ||
                        dataSelect.rateServicio == -2 ||
                        dataSelect.price_total <= 0
                      }
                      type="primary"
                      className="buttonModal"
                      disabled={
                        actionProgress || dataSelect.stateNumServi == "4"
                      }
                      onClick={() =>
                        setFlagModal({ ...flagModal, modal2: true })
                      }
                    >
                      Rechazar
                    </Button>
                  </>
                )}
              </div>
              <Modal
                visible={flagModal["modal2"]}
                title="Cotización"
                footer={[
                  <Button
                    disabled={actionProgress}
                    onClick={() =>
                      setFlagModal({ ...flagModal, modal2: false })
                    }
                    type="primary"
                  >
                    Cancelar
                  </Button>,
                  <Button
                    disabled={actionProgress}
                    onClick={() => {
                      handleGiveService();
                      setFlagModal({
                        ...flagModal,
                        modal2: false,
                        modal1: false,
                      });
                    }}
                    type="primary"
                  >
                    Rechazar
                  </Button>,
                ]}
                onCancel={() => setFlagModal({ ...flagModal, modal2: false })}
              >
                <div style={{ textAlign: "center" }}>
                  <Col>
                    esta seguro de rechazar la cotizacion ? <br />
                    Tendra un costo de $20000
                  </Col>
                </div>
              </Modal>
              {dataSelect.stateNumServi == 7 ? (
                <Modal
                  footer={[]}
                  visible={flagModal.modal3}
                  onCancel={() => setFlagModal({ ...flagModal, modal3: false })}
                >
                  <Descriptions
                    title="Calificación"
                    bordered
                    layout="vertical"
                    style={{ textAlign: "center" }}
                  >
                    <Descriptions.Item
                      label="Tecnico que hizo el servicio"
                      span={3}
                    >
                      {dataSelect.tecniconame}
                    </Descriptions.Item>
                    <Descriptions.Item label="Servicio" span={3}>
                      {dataSelect.id_categoria.nameCategory}
                    </Descriptions.Item>
                    <Descriptions.Item label="Calificación" span={3}>
                      <Rate
                        onChange={(valueA) =>
                          setDataSelect({ ...dataSelect, rateServicio: valueA })
                        }
                      />
                      {/* <Rate onChange = {(value) => console.log(value)} /> */}
                    </Descriptions.Item>

                    <div style={{ padding: "10px" }}>
                      <Button
                        disabled={actionProgress}
                        type="primary"
                        className="buttonModal"
                        onClick={() => handleGiveService(1)}
                      >
                        Aceptar
                      </Button>
                      <Button
                        type="primary"
                        className="buttonModal"
                        disabled={actionProgress}
                        onClick={() =>
                          setFlagModal({ ...flagModal, modal3: true })
                        }
                      >
                        Cancelar
                      </Button>
                    </div>
                  </Descriptions>
                </Modal>
              ) : (
                ""
              )}
            </Modal>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default ServiciosTable;
